import { defineStore } from 'pinia'

export const useNotificationStore = defineStore('notification-store', {
  state: () => ({
    notifications: [],
    snackbar: {
      show: false,
      message: '',
      link: null,
      timeout: 5000,
    },
  }),
  getters: {
    unreadCount: (state) => state.notifications.filter(n => !n.isSeen).length,
    allNotifications: (state) => state.notifications,
  },
  actions: {
    add({ type, title, message, duration = 5000 }) {
      const newNotification = {
        id: Date.now() + Math.random(),
        type,
        title,
        message,
        duration,
        timestamp: new Date().toISOString(),
      }

      this.showSnackbar({ message: `${title}: ${message}`, timeout: duration })

      return newNotification.id
    },

    addNotification({ type, title, subtitle, orderId, orderNumber, link, icon, color }) {
      const newNotification = {
        id: Date.now() + Math.random(),
        type,
        title,
        subtitle,
        orderId,
        orderNumber,
        link,
        icon: icon || 'tabler-bell-ringing',
        color: color || 'success',
        time: new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }),
        timestamp: new Date().toISOString(),
        isSeen: false,
      }

      this.notifications.unshift(newNotification)

      if (this.notifications.length > 50) {
        this.notifications = this.notifications.slice(0, 50)
      }

      return newNotification.id
    },

    markAsRead(notificationId) {
      const notification = this.notifications.find(n => n.id === notificationId)
      if (notification) {
        notification.isSeen = true
      }
    },

    markAllAsRead() {
      this.notifications.forEach(n => n.isSeen = true)
    },

    removeNotification(notificationId) {
      const index = this.notifications.findIndex(n => n.id === notificationId)
      if (index !== -1) {
        this.notifications.splice(index, 1)
      }
    },

    clearAll() {
      this.notifications = []
    },

    showSnackbar({ message, link = null, timeout = 5000 }) {
      this.snackbar.message = message
      this.snackbar.link = link
      this.snackbar.timeout = timeout
      this.snackbar.show = true
    },

    hideSnackbar() {
      this.snackbar.show = false
    },
  },
})
